export default "__VITE_ASSET__cokhaJ4k__ 640w, __VITE_ASSET__C37mnz8w__ 1024w";